



















import { Component, Watch } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class SwitchToggle extends BaseInput {
  public selected = (this.value || false)

  public mounted() {
    this.innerValue = this.selected
    setTimeout(() => {
      this.selected = this.value || false
    }, 100)
  }

  @Watch('selected')
  public onSelected() {
    this.innerValue = this.selected
  }
}
